import { Box, Button, Flex, Grid, Select, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  getMasterOrgAll,
  getTblDmEmployeeAll,
} from "../../../../service/getSelectApi";
import { IconCheck } from "@tabler/icons-react";

interface PersonnelConfigurationForGoodsManagerModel {
  id: number;
  idChiNhanh: number | null;
  maChiNhanh: string | null;
  tenChiNhanh: string | null;
  diaChi: string | null;
  mnv: string | null;
  hoVaTen: string | null;
  viTriLamViec: string | null;
  soDienThoaiLienLac: string | null;
  soDienThoaiZalo: string | null;
  email: string | null;
  createBy: number | null;
  createDate: string | null;
  lastUpdateBy: number | null;
  lastUpdateDate: string | null;
}

const CreatePersonnelConfigurationForGoodsManager = ({
  onSuccess,
  data,
}: {
  onSuccess: any;
  data: any;
}) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const [dataBranch, setDataBranch] = useState<any[]>([]);
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const form = useForm<PersonnelConfigurationForGoodsManagerModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      id: 0,
      idChiNhanh: null,
      maChiNhanh: null,
      tenChiNhanh: null,
      diaChi: null,
      mnv: null,
      hoVaTen: null,
      viTriLamViec: null,
      soDienThoaiLienLac: null,
      soDienThoaiZalo: null,
      email: null,
      createBy: null,
      createDate: null,
      lastUpdateBy: null,
      lastUpdateDate: null,
    },

    validate: {
      idChiNhanh: (value: number | null) => {
        if (!value) {
          return "Vui lòng chọn chi nhánh !";
        }
      },
      mnv: (value: string | null) => {
        if (!value) {
          return "Vui lòng chọn nhân viên !";
        }
      },
      soDienThoaiLienLac: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập số điện thoại !";
        }

        if (value && value.length !== 10) {
          return "Số điện thoại không hợp lệ !";
        }
      },
    },
  });

  const getDataBranch = async () => {
    const res = await getMasterOrgAll();

    if (res) {
      setDataBranch(res);
    }
  };

  const getDataEmployee = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      setDataEmployee(res);
    }
  };

  const handleSubmitData = async (
    dataSubmit: PersonnelConfigurationForGoodsManagerModel,
  ) => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        data ? "/api/v1/TblItemManager/edit" : "/api/v1/TblItemManager/create",
        dataSubmit,
      );

      if (res && res.success) {
        NotificationExtension.Success(
          data
            ? "Chỉnh sửa nhân viên quản lí hàng hóa thành công !"
            : "Thêm mới nhân viên quản lí hàng hóa thành công !",
        );

        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    Promise.all([getDataBranch(), getDataEmployee()]);
  }, []);

  useEffect(() => {
    if (data) {
      form.setValues(data);
    }
  }, [data]);

  return (
    <Box
      component="form"
      w={"100%"}
      onSubmit={form.onSubmit(
        (e: PersonnelConfigurationForGoodsManagerModel) => {
          handleSubmitData(e);
        },
      )}
    >
      <Grid mt={5}>
        <Grid.Col span={12}>
          <Select
            label="Chi nhánh"
            placeholder="Nhập tên hoặc mã chi nhánh"
            data={dataBranch
              .filter((i) => i.id && i.code && i.name)
              .map((i) => ({
                label: `${i.code} - ${i.name}`,
                value: String(i.id),
              }))}
            value={
              form.getValues().idChiNhanh
                ? String(form.getValues().idChiNhanh)
                : null
            }
            searchable
            clearable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            withAsterisk
            {...form.getInputProps("idChiNhanh")}
            onChange={(e) => {
              form.setValues((prev) => ({
                ...prev,
                idChiNhanh: e ? Number(e) : null,
                maChiNhanh: e
                  ? dataBranch.find((i) => String(i.id) === e).code || null
                  : null,
                tenChiNhanh: e
                  ? dataBranch.find((i) => String(i.id) === e).name || null
                  : null,
                diaChi: e
                  ? dataBranch.find((i) => String(i.id) === e).address || null
                  : null,
                mnv: null,
                hoVaTen: null,
                soDienThoaiLienLac: null,
              }));
            }}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Select
            label="Nhân viên"
            placeholder="Chọn nhân viên"
            data={dataEmployee
              .filter(
                (i) =>
                  String(i.branchId) === String(form.getValues().idChiNhanh) &&
                  i.code &&
                  i.fullname,
              )
              .map((i) => ({
                label: `${i.code} - ${i.fullname}`,
                value: String(i.code),
              }))}
            value={form.getValues().mnv ? String(form.getValues().mnv) : null}
            searchable
            clearable
            disabled={!form.getValues().idChiNhanh}
            nothingFoundMessage="Không tìm thấy dữ liệu !"
            withAsterisk
            {...form.getInputProps("mnv")}
            onChange={(e) => {
              form.setValues((prev) => ({
                ...prev,
                mnv: e ? String(e) : null,
                hoVaTen: e
                  ? dataEmployee.find((i) => String(i.code) === e)?.fullname ||
                    null
                  : null,
                soDienThoaiLienLac: e
                  ? dataEmployee.find((i) => String(i.code) === e)
                      ?.phoneNumber || null
                  : null,
              }));
            }}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label="Số điện thoại"
            placeholder="Nhập số điện thoại"
            value={form.getValues().soDienThoaiLienLac || ""}
            {...form.getInputProps("soDienThoaiLienLac")}
            onChange={(e) => {
              form.setValues((prev) => ({
                ...prev,
                soDienThoaiLienLac: e.currentTarget.value,
              }));
            }}
            disabled={!form.getValues().idChiNhanh}
            withAsterisk
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"center"} align={"center"} mt={5}>
        <Button
          leftSection={<IconCheck size={18} />}
          color="teal"
          type="submit"
          loading={visible}
          disabled={visible}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default CreatePersonnelConfigurationForGoodsManager;
